import { render, staticRenderFns } from "./PreRollVideoAd.vue?vue&type=template&id=2192b198&scoped=true"
import script from "./PreRollVideoAd.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreRollVideoAd.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreRollVideoAd.vue?vue&type=style&index=0&id=2192b198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192b198",
  null
  
)

export default component.exports